export default "__VITE_ASSET__B4IFX4P7__"